import { APP_VERSION } from "../../version.js";
import { ProfileEditModal } from "../../components/modals/ProfileEditModal.js";
import { locale as LocaleService } from "../../services/LocaleService.js";

export const SettingsTab = (target, user, { onEditProfile }) => {
    target.innerHTML = `
        <div class="p-4 space-y-4">
            <div class="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                <button class="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors text-left" onclick="window.auth.logout()">
                    <div class="flex items-center gap-3">
                        <div class="w-8 h-8 rounded-full bg-red-50 text-red-500 flex items-center justify-center">
                            <span class="material-symbols-outlined text-lg">logout</span>
                        </div>
                        <span class="text-gray-900 font-medium">${LocaleService.t('menu.logout')}</span>
                    </div>
                    <span class="material-symbols-outlined text-gray-300">chevron_right</span>
                </button>
                
                <!-- Edit Profile -->
                <button id="btn-settings-edit-profile" class="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors text-left border-t border-gray-100">
                    <div class="flex items-center gap-3">
                        <div class="w-8 h-8 rounded-full bg-blue-50 text-blue-500 flex items-center justify-center">
                            <span class="material-symbols-outlined text-lg">person_edit</span>
                        </div>
                        <span class="text-gray-900 font-medium">${LocaleService.t('mypage.menu_edit_profile')}</span>
                    </div>
                    <span class="material-symbols-outlined text-gray-300">chevron_right</span>
                </button>

                <!-- Link to Public Profile -->
                <button class="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors text-left border-t border-gray-100" onclick="window.router.navigate('/user/${user.uid}')">
                    <div class="flex items-center gap-3">
                        <div class="w-8 h-8 rounded-full bg-indigo-50 text-indigo-500 flex items-center justify-center">
                            <span class="material-symbols-outlined text-lg">public</span>
                        </div>
                        <span class="text-gray-900 font-medium">${LocaleService.t('mypage.menu_public_profile')}</span>
                    </div>
                    <span class="material-symbols-outlined text-gray-300">chevron_right</span>
                </button>
            </div>

            <div class="text-center py-8">
                 <p class="text-xs text-gray-400">${LocaleService.t('mypage.current_version')}</p>
                 <p class="text-sm font-bold text-gray-500 font-mono mt-1">${APP_VERSION}</p>
            </div>
        </div>
    `;

    // Bind edit profile
    const btnEdit = target.querySelector('#btn-settings-edit-profile');
    if (btnEdit && onEditProfile) {
        btnEdit.onclick = () => {
            onEditProfile();
        };
    }
};
